import { render, staticRenderFns } from "./CreateAreaModal.vue?vue&type=template&id=027cbeea"
import script from "./CreateAreaModal.vue?vue&type=script&lang=js"
export * from "./CreateAreaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports